import { Grid, GridProps, Typography } from "@mui/material";
import { ReactElement } from "react";

type RowProps = {
  label: string;
  field: ReactElement;
  gridContainerProps?: GridProps;
};

export const AssignmentRow = ({
  label,
  field,
  gridContainerProps = {},
}: RowProps) => (
  <>
    <Grid
      container
      item
      xs={2}
      justifyContent="flex-end"
      alignItems="center"
      {...gridContainerProps}
    >
      <Typography textAlign="right" color="textSecondary">
        {label}
      </Typography>
    </Grid>
    <Grid item xs={10}>
      {field}
    </Grid>
  </>
);
